import { render } from "./personalParents.vue?vue&type=template&id=1c976c68&scoped=true"
import script from "./personalParents.vue?vue&type=script&lang=js"
export * from "./personalParents.vue?vue&type=script&lang=js"

import "./personalParents.vue?vue&type=style&index=0&id=1c976c68&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c976c68"]])

export default __exports__